<div class="no-scroll patient-ob">
  <div class="wrapper">
    <!-- ========================== Header (Start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <i class="off-mobile header-icon icon-fetus" *ngIf="false"></i>

        <div class="header-pagi" *ngIf="false">
          <a href="#" class="header-pagi-item">1</a>
          <a href="#" class="header-pagi-item is-active">2</a>
          <a href="#" class="header-pagi-item">3</a>
        </div>

        <nav class="header-menu">
          <!-- <a href="#" class="header-menu-link icon-book" aria-label="library"></a> -->
          <!-- <a href="#" class="header-menu-link icon-print" aria-label="Print"></a> -->
          <a
            (click)="calendarForm = true; selectedForm = null; cf.selcForm = null"
            class="header-menu-link icon-calendar"
            matTooltip="Pregnancy Planner"
            style="background-color: white; border-radius: 5px; cursor: pointer"
            aria-label="calendar"
            *ngIf="!login.isCardio && !login.isGastro && login.premissions.Planner"
          ></a>
          <!-- <a href="#" class="header-menu-link icon-chart" aria-label="chart"></a> -->
          <!-- <a href="#" class="header-menu-link icon-image" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-searchdoc" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-save" aria-label="save"></a> -->
          <!-- <a href="#" class="header-menu-link icon-date" aria-label="date"></a> -->
          <!-- <a href="#" class="header-menu-link icon-confirm" aria-label="confirm"></a> -->
        </nav>

        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-headerMenu"
            data-show=".header-menu"
            aria-label="open mobile menu"
          ></button>
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
      </div>
    </header>
    <!-- ========================== Header (End) ========================== -->

    <!-- Sites: block-and-confirm clinic switch prompt. Floats next to the exact
         exam link that was clicked (see SiteSwitchPromptComponent) instead of a
         page-top banner disconnected from the click. -->
    <app-site-switch-prompt></app-site-switch-prompt>

    <!-- ========================== Dashboard Main Content (Start) ========================== -->

    <main class="l-deashboard">
      <div class="h100 l-flex l-flex-w t-boxMargin--spacebyPadding">
        <!-- ========================== Patient History Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div class="h100 m-box" *ngIf="pat.ID === 'default'" [formGroup]="examServe.newTitleItem">
            <h2>Additional Titles Setting</h2>
            <div class="h100 l-flex l-column" style="justify-content: space-between">
              <div>
                <div class="headDiv">
                  <div class="inputLine">
                    <section>
                      <span>Define new title:</span>
                      <input
                        class="input"
                        #inputTitle
                        type="text"
                        formControlName="Title"
                        [value]="examServe.newTitleItem.get('Title').value"
                      />
                    </section>
                    <span class="t-validation-wrap l-fg1" style="text-align: center">
                      <span class="s-count" *ngIf="examServe.CustomTitles">
                        <span [ngClass]="!examServe.disableSaveTitle ? '' : 'is-invalid'">
                          <strong
                            >{{ examServe.CustomTitles ? examServe.CustomTitles.length : 0 }}/8</strong
                          >
                        </span>
                        <div class="t-validation-message">
                          <span>Maximum Custom Titles, Please Remove One</span>
                        </div>
                      </span>
                    </span>
                    <button
                      (click)="examServe.saveNewTitle(login.ClinicID, false)"
                      style="background-color: #d7a95b; color: white; width: 4em; border-radius: 10px"
                    >
                      save
                    </button>
                  </div>
                </div>
                <div>
                  <div
                    class="linked-radios-list linked-radios-set"
                    style="margin-top: 0"
                    [formGroup]="examServe.newTitleItem"
                  >
                    <label class="linked-radios-item" *ngFor="let c of examServe.CustomTitles">
                      <input
                        type="radio"
                        [value]="c.AutoIndex"
                        formControlName="AutoIndex"
                        (click)="examServe.getTitle(c.AutoIndex)"
                      />
                      <span class="linked-radios-row">
                        <span
                          class="l-fg1 linked-radios-title"
                          (dblclick)="examServe.resetTitleItem()"
                          >{{ c.Title }}</span
                        >
                        <span class="linked-radios-duration" style="margin-inline-end: 5em">
                          <p>
                            {{ c.Creation | date : "dd/MM/yyyy" }} at {{ c.Creation | date : "HH:mm" }}
                          </p>
                        </span>
                        <span class="linked-radios-duration"
                          ><img
                            src="../../assets/icons/del.svg"
                            matTooltip="Delete"
                            (click)="examServe.deleteTitle(c.AutoIndex)"
                        /></span>
                        <!-- <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Fetal Echo']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)='deleteDefault("Specialized")'> 12-40 Weeks</span> -->
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch"> Exit Titles Setting </a>
                <!-- <button class="patient-ob-btn -start_exam" [ngClass]="examname && etype ? '': 'opaque'"
                                    (click)="startExam()" *ngIf="canOpen()">
                                    {{pat.ID != 'default' ? (etype!= 'Forms'?'Start Exam': 'New Letter') :
                                    'Construct/Edit Defaults'}}
                                </button> -->
              </div>
            </div>
          </div>
          <div class="h100 m-box" *ngIf="pat.ID != 'default'">
            <h2>Patient History</h2>

            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="notFormExams && notFormExams.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em"> Exams </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of notFormExams">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="l-fg1 examlink"
                      (click)="goExam(null, exam, exam.ExamType, exam.CreationTime, $event)"
                      (contextmenu)="askDelete(exam)"
                    >
                      {{ "exam.type.Eyes." + exam.ExamType | translate }}
                      <ng-container *ngIf="exam.Locked"
                        ><img src="../../assets/icons/login/password.svg" style="height: 1em" />{{
                          exam.LockedBy
                        }}</ng-container
                      >
                    </span>
                    <span style="margin-right: 2em"> by {{ exam.Opener }} </span>
                    <span
                      *ngIf="login.isCardio && exam.ClosedDate"
                      style="margin-right: 2em"
                      >Signed by {{ exam.TerminationRemarks }},
                      {{ exam.ClosedDate | date : "dd/MM/yyyy" }}</span
                    >
                    <span *ngIf="login.isCardio && !exam.ClosedDate" style="margin-right: 2em"
                      >Not Reviewed</span
                    >
                    <span class="linked-radios-date"
                      >{{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}</span
                    >
                  </ng-container>
                </li>
              </ul>
            </div>

            <div class="linked-radios-list linked-radios-set" *ngIf="ecgExams && ecgExams.length > 0">
              <strong class="linked-radios-row" style="margin-bottom: 1em"> ECG </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of ecgExams">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="l-fg1 examlink"
                      (click)="goExam(null, exam, exam.ExamType, exam.CreationTime, $event)"
                      (contextmenu)="askDelete(exam)"
                    >
                      {{ exam.ExamType }}
                      <ng-container *ngIf="exam.Locked"
                        ><img src="../../assets/icons/login/password.svg" style="height: 1em" />{{
                          exam.LockedBy
                        }}</ng-container
                      >
                    </span>
                    <span style="margin-right: 2em">by {{ exam.Opener }}</span>
                    <span *ngIf="login.isCardio && exam.ClosedDate" style="margin-right: 2em"
                      >Signed {{ exam.ClosedDate | date : "dd/MM/yyyy" }}</span
                    >
                    <span *ngIf="login.isCardio && !exam.ClosedDate" style="margin-right: 2em"
                      >Not Reviewed</span
                    >
                    <span class="linked-radios-date"
                      >{{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}</span
                    >
                  </ng-container>
                </li>
              </ul>
            </div>

            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="formsExams && formsExams.length > 0"
            >
              <strong class="linked-radios-row">Letters and Certificates </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of formsExams">
                  <ng-container *ngIf="FORMS.includes(exam.ExamType)">
                    <span
                      class="l-fg1 examlink"
                      (click)="goExam(null, exam, exam.ExamType, exam.CreationTime, $event)"
                      (contextmenu)="askDelete(exam)"
                    >
                      {{ exam.ExamType }}
                      <ng-container *ngIf="exam.Locked"
                        ><img src="../../assets/icons/login/password.svg" style="height: 1em" />{{
                          exam.LockedBy
                        }}</ng-container
                      >
                    </span>
                    <span style="margin-right: 2em">by {{ exam.Opener }}</span>
                    <span class="linked-radios-date"
                      >{{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}</span
                    >
                  </ng-container>
                </li>
              </ul>
            </div>

            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="
                login.premissions &&
                login.premissions.Questionnaires &&
                patientQuestionnaires &&
                patientQuestionnaires.length > 0
              "
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em">{{ 'GUI.General.Buttons.Questionnaires' | translate }}</strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let q of patientQuestionnaires">
                  <span
                    class="l-fg1 examlink"
                    [style.cursor]="q.answeredDate ? 'pointer' : 'default'"
                    (click)="openQuestionnairePdf(q)"
                  >
                    {{ q.name }}
                  </span>
                  <span
                    style="margin-right: 2em; padding: 0.1em 0.6em; border-radius: 10px; color: #fff"
                    [style.background-color]="q.answeredDate ? '#4caf50' : '#d7a95b'"
                  >
                    {{ q.answeredDate ? 'Answered' : 'Pending' }}
                  </span>
                  <span class="linked-radios-date">{{
                    (q.answeredDate || q.sentDate) | date : "dd/MM/yyyy"
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- ========================== Patient History Panel (End) ========================== -->

        <!-- ========================== Create New Exam Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div class="h100 m-box">
            <h2>{{ pat.ID != "default" ? "Create New" : "Exams Defaults Setting" }}</h2>

            <div class="h100 l-flex l-column" style="height: fit-content">
              <div class="l-fg1">
                <div class="">
                  <!-- ========================== New Exam Type Selector (Start) ========================== -->
                  <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                    <label class="t-label-top" *ngIf="login.isCardio && login.category.name != 'forms'">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Eyes"
                      />
                      <i class="customInput-display"></i>
                      <span> Eyes </span>
                    </label>
                  </div>
                  <!-- ========================== New Exam Type Selector (End) ========================== -->

                  <div class="linked-radios-list linked-radios-set">
                    <ng-container *ngIf="etype == 'Forms'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Consultation Letter"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Consultation Letter</span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Inform Consent"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Inform Consent</span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label
                        class="linked-radios-item"
                        *ngIf="login.premissions && login.premissions.Questionnaires"
                      >
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Send Questionnaire"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">{{ 'appointments.gui.questionnaires.New Questionnaire' | translate }}</span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype == 'Eyes'">
                      <!-- for old oct exams -->
                      <ng-container
                        *ngIf="
                          login.premissions &&
                          !login.premissions.OCTOptic &&
                          !login.premissions.OCTMacular
                        "
                      >
                        <label class="linked-radios-item">
                          <input type="radio" name="TEMP_name1" value="OCT" [(ngModel)]="examname" />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              OCT
                              <img
                                *ngIf="defaults && defaults['OCT']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('OCT')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.OCTOptic">
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_name1"
                            value="OCTOptic"
                            [(ngModel)]="examname"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              OCT Optic
                              <img
                                *ngIf="defaults && defaults['OCTOptic']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('OCTOptic')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.OCTMacular">
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_name1"
                            value="OCTMacular"
                            [(ngModel)]="examname"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              OCT Macular
                              <img
                                *ngIf="defaults && defaults['OCTMacular']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('OCTMacular')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.TOPEye">
                        <label class="linked-radios-item">
                          <input type="radio" name="TEMP_name1" value="TOPEye" [(ngModel)]="examname" />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              TOP
                              <img
                                *ngIf="defaults && defaults['TOPEye']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('TOPEye')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.FOV">
                        <label class="linked-radios-item">
                          <input type="radio" name="TEMP_name1" value="FOV" [(ngModel)]="examname" />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              FOV
                              <img
                                *ngIf="defaults && defaults['FOV']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('FOV')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.Pachymetry">
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_name1"
                            value="Pachymetry"
                            [(ngModel)]="examname"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              Pachymetry
                              <img
                                *ngIf="defaults && defaults['Pachymetry']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('Pachymetry')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>

                      <ng-container *ngIf="login.premissions && login.premissions.Fundus">
                        <label class="linked-radios-item">
                          <input type="radio" name="TEMP_name1" value="Fundus" [(ngModel)]="examname" />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">
                              Fundus
                              <img
                                *ngIf="defaults && defaults['Fundus']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete"
                                (click)="deleteDefault('Fundus')"
                              />
                            </span>
                            <span class="linked-radios-counter"><i>1</i></span>
                          </span>
                        </label>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                  {{ pat.ID != "default" ? "Exit Patient" : "Exit Defaults" }}
                </a>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="examname && etype ? '' : 'opaque'"
                  [disabled]="!login.isCardio && !login.category.canCreate.exam"
                  (click)="startExam()"
                  *ngIf="canOpen() && etype != 'GastroForms' && examname != 'Inform Consent'"
                >
                  {{
                    pat.ID != "default"
                      ? examname == "Send Questionnaire"
                        ? ("appointments.gui.questionnaires.New Questionnaire" | translate)
                        : etype != "Forms" && etype != "GastroForms"
                        ? "Start Exam"
                        : etype == "GastroForms"
                        ? "New Form"
                        : "New Letter"
                      : "Construct/Edit Defaults"
                  }}
                </button>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="examname && etype ? '' : 'opaque'"
                  [disabled]="!login.category.canCreate.form"
                  (click)="startForm()"
                  *ngIf="etype == 'GastroForms' || examname == 'Inform Consent'"
                >
                  {{ pat.ID != "default" ? "New Form" : "Construct/Edit Defaults" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- ========================== Create New Exam Panel (End) ========================== -->
      </div>
      <!-- box margin -->
    </main>
    <!-- ========================== Dashboard Main Content (End) ========================== -->

    <!-- ========================== Main Sidebar (Start) ========================== -->

    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- ========================== User Panel (Start) ========================== -->
      <div class="userPanel" *ngIf="pat.ID != 'default'">
        <i class="userPanel-icon icon-female">
          <button class="btn-user_data" aria-label="user data" (click)="showPat = true"></button>
        </i>

        <div class="userPanel-userName">
          {{ pat.First + " " + pat.Last }}
        </div>

        <dl class="l-table userPanel-userInfo">
          <div class="l-row">
            <dt class="l-td-m">ID Number</dt>
            <dd class="l-td-m">{{ pat.ID }}</dd>
          </div>
          <div class="l-row">
            <dt class="l-td-m">Age</dt>
            <dd class="l-td-m">{{ patService.getAgeMo() }}</dd>
          </div>
          <div class="l-row" *ngIf="!login.isGastro && !login.isCardio">
            <dt class="l-td-m">GA</dt>
            <dd class="l-td-m">{{ pat.getGA() }}</dd>
          </div>
          <div class="l-row" style="margin-top: 1em" *ngIf="login.getArchiveServer()">
            <dt class="l-td-m">History</dt>
            <dd class="l-td-m">
              <a target="_blank" [href]="login.getArchiveServer() + pat.ID"
                ><img src="../../assets/icons/oldarchive.svg" style="height: 2.2em; margin-top: 1em"
              /></a>
            </dd>
          </div>
        </dl>
      </div>
      <!-- ========================== User Panel (End) ========================== -->

      <!-- ========================== Main Nav (Start) ========================== -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- ========================== Main Nav (End) ========================== -->

      <app-docpanel [disableSiteSwitch]="true"></app-docpanel>
    </aside>

    <!-- ========================== Main Sidebar (End) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->
  <!-- ========================== Delete Confirmation Popup (Start) ========================== -->
  <div class="t-popup popup-patientDetails" *ngIf="toDelete" style="display: block; max-width: 40vw">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="toDelete = null; readydelete = false"
        ></button>

        <h2 style="color: D7A95B">
          Delete {{ toDelete.ExamType }}
          {{ defaults ? "defaults" : "exam from today at " + (toDelete.CreationTime | date : "HH:mm") }}?
        </h2>
        <!-- box (end) -->
        <div *ngIf="!readydelete">
          <button (click)="readydelete = true">yes</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">no</button>
        </div>
        <div *ngIf="readydelete">
          WARNING exam data and media will we lost!<br />
          <button (click)="deleteExam()">OK</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================== Delete Confirmation Popup (End) ========================== -->

  <!-- ========================== Dynamic Popup Components (Start) ========================== -->
  <app-patdetails *ngIf="showPat" [pat]="pat" (closed)="showPat = false"></app-patdetails>
  <app-patforms *ngIf="typeForm" (closed)="typeForm = false"></app-patforms>
  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [form]="concentForm"
    [ExamType]="examname"
  ></app-informconcent>

  <app-commerror></app-commerror>
  <app-calexams
    *ngIf="calendarForm"
    (closed)="closCalForm($event)"
    [selectedForm]="selectedForm"
  ></app-calexams>
  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [isnew]="newExam"
  ></app-loginbox>
  <app-closepregnancy
    *ngIf="closePreg"
    [pregtoload]="closePreg"
    [exams]="pregExams"
    (examClosed)="pregClosed()"
    (closed)="closePreg = null"
  ></app-closepregnancy>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="onSendQuestionnaireClosed()"
  ></app-send-questionnaire>
  <!-- ========================== Dynamic Popup Components (End) ========================== -->
</div>
